export default class ProjetoFileUploaderController {
  constructor($dialog, TipoAnexo, FileUploader, ProjetoAnexo, UIService, pID, file) {
    this.dialog = $dialog;
    this.UI = UIService;
    this.pID = pID;
    this.ProjetoAnexo = ProjetoAnexo;
    this.progress = 0;
    this.uploading = false;
    this.replace = false;
    this.edit = angular.isDefined(file);
    this.fileEdit = file;

    this.uuid = this.generateUUID() + ".pdf";

    this.data = {
      auxTipo: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      anexo: undefined,
      nome: this.uuid,
      descricao: null
    };

    TipoAnexo.find({
      filter: {
        where: {
        }
      }
    }).$promise.then(res => {
      this.loaded = true;
      this.tipos = res;
    });
    // Setup file uploader
    this.uploader = new FileUploader({
      url: '/api/Upload/projects/upload',
      queueLimit: 1
    });

    // Infinite Scroll magic
    this.addMoreItems = (infiniteScroll) => {
      infiniteScroll.currentItems += infiniteScroll.numToAdd;
    };


    // Enforce PDF Files
    this.uploader.filters.push({
      name: 'verifyPDF',
      fn: function (item, options) {
        let type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
        return '|pdf|'.indexOf(type) !== -1;
      }
    });

    // Force queue limit = 1
    this.uploader.onAfterAddingFile = () => {
      if (this.uploader.queue.length > 1) {
        this.uploader.queue.splice(0, this.uploader.queue.length - 1);
      }
    };

    this.uploader.onBeforeUploadItem = (item) => {
      let partes = item.file.name.split(".");
      item.file.name = this.generateUUID();
      if (partes.length > 1) item.file.name += "." + partes[partes.length - 1];
    //  item.file.name = this.uuid;
      if (this.replace) {
        // Remove older item
        this.replacefile.active = 0;
        this.ProjetoAnexo.upsert(this.replacefile);
      }
      this.ProjetoAnexo.create({
        id: 0,
        projetoId: this.pID,
        tipoAnexoId: this.edit ? this.fileEdit.tipoAnexoId : this.data.auxTipo.selected.id,
        nome: item.file.name,
        descricao: this.data.descricao,
        active: true
      }).$promise.then((res) => {
        this.entry = res;
      });
    };

    this.uploader.onWhenAddingFileFailed = () => {
      this.UI.addToast('Erro ao adicionar ficheiro. Verifique o tipo de ficheiro');
      this.cancel();
    };

    this.uploader.onSuccessItem = () => {
      this.dialog.close({
        replace: this.replace,
        data: this.data
      });
    };

    this.uploader.onProgressItem = (item, progress) => {
      this.progress = progress;
    };

    this.uploader.onErrorItem = () => {
      // Remove entry of BD
      if (this.entry) {
        this.UI.addToast("Erro no carregamento. Por favor remova esta entrada.");
      }
    }
  }

  ok = () => {
    if (this.edit === false) {
      //  Show progress for upload
      this.uploading = true;
      this.progress = 0;
      // Upload file
      this.uploader.uploadAll();
    } else {
      // Editing, replace file
      //  Show progress for upload
      this.uploading = true;
      this.replace = true;
      this.replacefile = this.fileEdit;
      this.progress = 0;
      // Upload file
      this.uploader.uploadAll();
    }
  };

  cancel = () => {
    this.dialog.dismiss('cancel');
  };

  generateUUID = () => {
    let uuid = "", i, random;
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0;
      if (i == 8 || i == 12 || i == 16 || i == 20) {
        uuid += "-";
      }
      uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
  };

}

ProjetoFileUploaderController.$inject = ['$dialog', 'TipoAnexo', 'FileUploader', 'ProjetoAnexo', 'UIService', 'pID', 'file'];
